import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "file-info" }
const _hoisted_2 = { class: "iconed-block-list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-folder" })
], -1)
const _hoisted_4 = { href: "javascript:void(0)" }
const _hoisted_5 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_6 = {
  key: 0,
  class: "lowercase-text"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  href: "javascript:void(0)"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 2,
  href: "javascript:void(0)"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 3,
  href: "javascript:void(0)"
}
const _hoisted_14 = { class: "doted-list" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "file-actions" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_20 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt mr-2" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download mr-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_RenameModal = _resolveComponent("RenameModal")
  const _component_DetailModal = _resolveComponent("DetailModal")
  const _component_DeleteModal = _resolveComponent("DeleteModal")
  const _component_ShareModal = _resolveComponent("ShareModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.folders, (folder, folderIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "col-lg-3 col-md-4 col-sm-6 px-2 mb-2",
        key: folderIndex
      }, [
        _createVNode("div", {
          class: 
        folder.isChecked
          ? 'shadowed-card bg-white mb-2 doc-card doc-active-card'
          : 'shadowed-card bg-white mb-2 doc-card'
      
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("ul", {
                onClick: ($event: any) => (_ctx.redirectToDocument(folder))
              }, [
                _createVNode("li", null, [
                  _hoisted_3,
                  _createVNode("h5", null, [
                    _createVNode("a", _hoisted_4, _toDisplayString(folder.name), 1)
                  ])
                ]),
                _createVNode("li", null, [
                  _createVNode("h5", null, [
                    (folder.child_folders && folder.child_folders.length)
                      ? (_openBlock(), _createBlock("a", _hoisted_5, [
                          (folder.child_folders.length === 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(folder.child_folders.length) + " " + _toDisplayString(_ctx.$t('folder')), 1))
                            : _createCommentVNode("", true),
                          (folder.child_folders.length > 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(folder.child_folders.length) + " " + _toDisplayString(_ctx.$t('folders')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
                    folder.files &&
                    folder.files.length &&
                    folder.child_folders &&
                    !folder.child_folders.length
                  )
                      ? (_openBlock(), _createBlock("a", _hoisted_8, [
                          (folder.files.length === 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(folder.files.length) + " " + _toDisplayString(_ctx.$t('file')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("a", _hoisted_10, [
                          (folder.files && folder.files.length === 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_11, ", " + _toDisplayString(folder.files.length) + " file", 1))
                            : _createCommentVNode("", true),
                          (folder.files && folder.files.length > 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_12, ", " + _toDisplayString(folder.files.length) + " files", 1))
                            : _createCommentVNode("", true)
                        ])),
                    (
                    folder.child_folders &&
                    !folder.child_folders.length &&
                    folder.files &&
                    !folder.files.length
                  )
                      ? (_openBlock(), _createBlock("a", _hoisted_13, [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('empty')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("ul", null, [
                (folder.created_date)
                  ? (_openBlock(), _createBlock("li", _hoisted_15, _toDisplayString(_ctx.formatDate(folder.created_date)), 1))
                  : _createCommentVNode("", true),
                (folder.convertedFileSize)
                  ? (_openBlock(), _createBlock("li", _hoisted_16, _toDisplayString(folder.convertedFileSize), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _createVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:void(0)",
                  "data-toggle": "modal",
                  onClick: ($event: any) => (_ctx.showDetailModal(folder))
                }, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('details')), 1)
                ], 8, ["onClick"]),
                _createVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:void(0)",
                  "data-toggle": "modal",
                  onClick: ($event: any) => (_ctx.showRenameModal(folder))
                }, [
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('rename')), 1)
                ], 8, ["onClick"]),
                _createVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:void(0)",
                  onClick: ($event: any) => (_ctx.downloadFolder(folder))
                }, [
                  _hoisted_23,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                ], 8, ["onClick"]),
                (!folder.project_id)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      class: "dropdown-item",
                      href: "javascript:void(0)",
                      "data-toggle": "modal",
                      onClick: ($event: any) => (_ctx.showDeleteFolderModal(folder))
                    }, [
                      _hoisted_24,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 2)
      ]))
    }), 128)),
    (_ctx.state.data.showRenameModal)
      ? (_openBlock(), _createBlock(_component_RenameModal, {
          key: 0,
          showModal: _ctx.state.data.showRenameModal,
          onClose: _ctx.closeSuccessModal
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_25, [
              _createVNode("h5", _hoisted_26, _toDisplayString(_ctx.$t('rename')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeRenameModal && _ctx.closeRenameModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_27
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.renameSelectedFolder,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_29, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "https://www.dropbox.com/s/11ydxpibqs2c5cr/01-Homepage-01.jpg?dl=0",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.folderRename = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.folderRename]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.renameSelectedFolder && _ctx.renameSelectedFolder(...args))),
                disabled: _ctx.state.ui.isPostLoading.renameSelectedFolder
              }, _toDisplayString(_ctx.state.ui.isPostLoading.renameSelectedFolder
            ? _ctx.$t('saving')
            : _ctx.$t('save_changes')), 9, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeRenameModal && _ctx.closeRenameModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ]),
          _: 1
        }, 8, ["showModal", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDetailModal)
      ? (_openBlock(), _createBlock(_component_DetailModal, {
          key: 1,
          onClose: _ctx.closeDetailModal,
          showModal: _ctx.state.data.showDetailModal,
          selected: _ctx.state.data.selectedFolder
        }, null, 8, ["onClose", "showModal", "selected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_DeleteModal, {
          key: 2,
          onClose: _ctx.closeDeleteModal,
          showModal: _ctx.state.data.showDeleteModal,
          folderId: _ctx.state.data.selectedFolder.uuid
        }, null, 8, ["onClose", "showModal", "folderId"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showShareModal)
      ? (_openBlock(), _createBlock(_component_ShareModal, {
          key: 3,
          onClose: _ctx.closeShareModal,
          selectedFolder: _ctx.selectedFolders
        }, null, 8, ["onClose", "selectedFolder"]))
      : _createCommentVNode("", true)
  ], 64))
}